import { SvgIcon } from "@mui/material";

export const CompanyIcon = () => (
  <SvgIcon>
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.25 21H4.25C2.25 21 1.25 20 1.25 18V10C1.25 8 2.25 7 4.25 7H9.25V18C9.25 20 10.25 21 12.25 21Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.36 3C9.28 3.3 9.25 3.63 9.25 4V7H4.25V5C4.25 3.9 5.15 3 6.25 3H9.36Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.25 7V12"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.25 7V12"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.25 16H14.25C13.7 16 13.25 16.45 13.25 17V21H17.25V17C17.25 16.45 16.8 16 16.25 16Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.25 12V16"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25 18V4C9.25 2 10.25 1 12.25 1H18.25C20.25 1 21.25 2 21.25 4V18C21.25 20 20.25 21 18.25 21H12.25C10.25 21 9.25 20 9.25 18Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const PersonalIdIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7399 2.23L5.74991 4.1C4.59991 4.53 3.65991 5.89 3.65991 7.12V14.55C3.65991 15.73 4.43991 17.28 5.38991 17.99L9.68991 21.2C11.0999 22.26 13.4199 22.26 14.8299 21.2L19.1299 17.99C20.0799 17.28 20.8599 15.73 20.8599 14.55V7.12C20.8599 5.89 19.9199 4.53 18.7699 4.1L13.7799 2.23C12.9299 1.92 11.5699 1.92 10.7399 2.23Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2499 10.92H12.1199C11.1799 10.89 10.4299 10.11 10.4299 9.16002C10.4299 8.19002 11.2199 7.40002 12.1899 7.40002C13.1599 7.40002 13.9499 8.19002 13.9499 9.16002C13.9399 10.12 13.1899 10.89 12.2499 10.92Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.2598 13.72C9.29979 14.36 9.29979 15.41 10.2598 16.05C11.3498 16.78 13.1398 16.78 14.2298 16.05C15.1898 15.41 15.1898 14.36 14.2298 13.72C13.1498 12.99 11.3598 12.99 10.2598 13.72Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const SecurityIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.1601 11.12C21.1601 16.01 17.6101 20.59 12.7601 21.93C12.4301 22.02 12.0701 22.02 11.7401 21.93C6.89009 20.59 3.34009 16.01 3.34009 11.12V6.73001C3.34009 5.91001 3.96009 4.98001 4.73009 4.67001L10.3001 2.39001C11.5501 1.88001 12.9601 1.88001 14.2101 2.39001L19.7801 4.67001C20.5401 4.98001 21.1701 5.91001 21.1701 6.73001L21.1601 11.12Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.25 12.5C12.7804 12.5 13.2891 12.2893 13.6642 11.9142C14.0393 11.5391 14.25 11.0304 14.25 10.5C14.25 9.96957 14.0393 9.46086 13.6642 9.08579C13.2891 8.71071 12.7804 8.5 12.25 8.5C11.7196 8.5 11.2109 8.71071 10.8358 9.08579C10.4607 9.46086 10.25 9.96957 10.25 10.5C10.25 11.0304 10.4607 11.5391 10.8358 11.9142C11.2109 12.2893 11.7196 12.5 12.25 12.5Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.25 12.5V15.5"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-miterlimit="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const HourGlassIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.49 2H9.01004C5.25004 2 4.96004 5.38 6.99004 7.22L17.51 16.78C19.54 18.62 19.25 22 15.49 22H9.01004C5.25004 22 4.96004 18.62 6.99004 16.78L17.51 7.22C19.54 5.38 19.25 2 15.49 2Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const BookmarkIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.25 8.99V20.35C16.25 21.8 15.21 22.41 13.94 21.71L10.01 19.52C9.59 19.29 8.91 19.29 8.49 19.52L4.56 21.71C3.29 22.41 2.25 21.8 2.25 20.35V8.99C2.25 7.28 3.65 5.88 5.36 5.88H13.14C14.85 5.88 16.25 7.28 16.25 8.99Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M22.25 5.11V16.47C22.25 17.92 21.21 18.53 19.94 17.83L16.25 15.77V8.99C16.25 7.28 14.85 5.88 13.14 5.88H8.25V5.11C8.25 3.4 9.65 2 11.36 2H19.14C20.85 2 22.25 3.4 22.25 5.11Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.25 12H11.25"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.25 14V10"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const PadlockIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.25 10V8C6.25 4.69 7.25 2 12.25 2C17.25 2 18.25 4.69 18.25 8V10"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.25 22H7.25C3.25 22 2.25 21 2.25 17V15C2.25 11 3.25 10 7.25 10H17.25C21.25 10 22.25 11 22.25 15V17C22.25 21 21.25 22 17.25 22Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.2461 16H16.2561"
        stroke="#2D68F7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2451 16H12.2551"
        stroke="#2D68F7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.24512 16H8.25312"
        stroke="#2D68F7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const TeamIcon = () => (
  <SvgIcon>
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.2498 7.16C18.1869 7.14999 18.1228 7.14999 18.0598 7.16C17.3925 7.13587 16.7606 6.85321 16.2979 6.37176C15.8351 5.89032 15.5776 5.2478 15.5798 4.58C15.5798 3.15 16.7298 2 18.1598 2C18.8441 2 19.5003 2.27182 19.9842 2.75566C20.468 3.23951 20.7398 3.89574 20.7398 4.58C20.738 5.24827 20.4778 5.88996 20.0138 6.37081C19.5497 6.85167 18.9176 7.13445 18.2498 7.16Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.2199 14.44C18.5899 14.67 20.0999 14.43 21.1599 13.72C22.5699 12.78 22.5699 11.24 21.1599 10.3C20.0899 9.58997 18.5599 9.34997 17.1899 9.58997"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.21998 7.16C6.27998 7.15 6.34998 7.15 6.40998 7.16C7.07735 7.13587 7.70919 6.85321 8.17197 6.37176C8.63476 5.89032 8.89223 5.2478 8.88998 4.58C8.88998 3.15 7.73998 2 6.30998 2C5.62572 2 4.96949 2.27182 4.48564 2.75566C4.0018 3.23951 3.72998 3.89574 3.72998 4.58C3.73998 5.98 4.83998 7.11 6.21998 7.16Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.24994 14.44C5.87994 14.67 4.36994 14.43 3.30994 13.72C1.89994 12.78 1.89994 11.24 3.30994 10.3C4.37994 9.58997 5.90994 9.34997 7.27994 9.58997"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.2498 14.63C12.1869 14.62 12.1228 14.62 12.0598 14.63C11.3925 14.6058 10.7606 14.3232 10.2979 13.8417C9.83507 13.3603 9.5776 12.7178 9.57985 12.05C9.57985 10.62 10.7298 9.46997 12.1598 9.46997C12.8441 9.46997 13.5003 9.74179 13.9842 10.2256C14.468 10.7095 14.7398 11.3657 14.7398 12.05C14.7298 13.45 13.6298 14.59 12.2498 14.63Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33997 17.78C7.92997 18.72 7.92997 20.26 9.33997 21.2C10.94 22.27 13.56 22.27 15.16 21.2C16.57 20.26 16.57 18.72 15.16 17.78C13.57 16.72 10.94 16.72 9.33997 17.78Z"
        stroke="#2D68F7"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const LogoIcon = () => (
  <SvgIcon>
    <svg
      width="115"
      height="24"
      viewBox="0 0 115 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.3183 7.93715H14.5022C14.9384 7.95904 15.3496 8.14818 15.6506 8.46544C15.9516 8.78271 16.1195 9.20383 16.1195 9.6417C16.1195 10.0796 15.9516 10.5007 15.6506 10.8179C15.3496 11.1352 14.9384 11.3243 14.5022 11.3462H4.32171C3.88548 11.3243 3.47432 11.1352 3.17329 10.8179C2.87226 10.5007 2.70438 10.0796 2.70438 9.6417C2.70438 9.20383 2.87226 8.78271 3.17329 8.46544C3.47432 8.14818 3.88548 7.95904 4.32171 7.93715H4.3183ZM3.46709 13.0512H13.651C14.1025 13.0512 14.5355 13.231 14.8547 13.5511C15.174 13.8711 15.3534 14.3052 15.3534 14.7579C15.3534 15.2105 15.174 15.6446 14.8547 15.9646C14.5355 16.2847 14.1025 16.4645 13.651 16.4645H3.4705C3.01899 16.4645 2.58597 16.2847 2.2667 15.9646C1.94743 15.6446 1.76808 15.2105 1.76808 14.7579C1.76808 14.3052 1.94743 13.8711 2.2667 13.5511C2.58597 13.231 3.01899 13.0512 3.4705 13.0512H3.46709ZM2.61588 18.1644H12.7997C13.2513 18.1644 13.6843 18.3442 14.0035 18.6642C14.3228 18.9843 14.5022 19.4184 14.5022 19.8711C14.5022 20.3237 14.3228 20.7578 14.0035 21.0779C13.6843 21.3979 13.2513 21.5777 12.7997 21.5777H2.61929C2.16778 21.5777 1.73476 21.3979 1.41549 21.0779C1.09623 20.7578 0.91687 20.3237 0.91687 19.8711C0.91687 19.4184 1.09623 18.9843 1.41549 18.6642C1.73476 18.3442 2.16778 18.1644 2.61929 18.1644H2.61588ZM19.583 7.93715H29.7635C30.1997 7.95904 30.6109 8.14818 30.9119 8.46544C31.2129 8.78271 31.3808 9.20383 31.3808 9.6417C31.3808 10.0796 31.2129 10.5007 30.9119 10.8179C30.6109 11.1352 30.1997 11.3243 29.7635 11.3462H19.583C19.1468 11.3243 18.7356 11.1352 18.4346 10.8179C18.1336 10.5007 17.9657 10.0796 17.9657 9.6417C17.9657 9.20383 18.1336 8.78271 18.4346 8.46544C18.7356 8.14818 19.1468 7.95904 19.583 7.93715ZM18.7318 13.0512H28.9123C29.3638 13.0512 29.7968 13.231 30.1161 13.5511C30.4354 13.8711 30.6147 14.3052 30.6147 14.7579C30.6147 15.2105 30.4354 15.6446 30.1161 15.9646C29.7968 16.2847 29.3638 16.4645 28.9123 16.4645H18.7318C18.2803 16.4645 17.8473 16.2847 17.528 15.9646C17.2088 15.6446 17.0294 15.2105 17.0294 14.7579C17.0294 14.3052 17.2088 13.8711 17.528 13.5511C17.8473 13.231 18.2803 13.0512 18.7318 13.0512ZM17.8806 18.1644C18.2176 18.1632 18.5473 18.2623 18.8281 18.4491C19.1088 18.6359 19.3279 18.902 19.4577 19.2138C19.5875 19.5255 19.622 19.8689 19.557 20.2003C19.492 20.5318 19.3303 20.8364 19.0925 21.0757C18.8546 21.315 18.5513 21.4781 18.2209 21.5445C17.8905 21.6108 17.5479 21.5774 17.2365 21.4484C16.925 21.3194 16.6588 21.1006 16.4715 20.8198C16.2842 20.539 16.1842 20.2089 16.1842 19.8711C16.1842 19.4195 16.3627 18.9862 16.6807 18.6663C16.9987 18.3465 17.4301 18.166 17.8806 18.1644Z"
        fill="#0053FD"
      />
      <path
        d="M48.0646 7.8425C49.0151 7.8425 49.8263 8.00996 50.4972 8.34543C51.1867 8.66226 51.7269 9.14727 52.1183 9.79953C52.5281 10.4331 52.7335 11.234 52.7335 12.2029C52.7335 13.4141 52.3703 14.3184 51.6437 14.9148C50.9355 15.5112 49.8165 15.8093 48.2882 15.8093H42.8927V13.4616H47.4503C48.3819 13.4615 48.8478 13.0511 48.8478 12.2312C48.8478 11.4299 48.3819 11.0291 47.4503 11.029H44.4865C43.5174 11.0291 42.7255 11.3553 42.1105 12.0075C41.4955 12.6598 41.1877 13.5543 41.1876 14.6911C41.1876 15.2502 41.2902 15.8098 41.4952 16.3689C41.7003 16.9093 42.073 17.3566 42.6134 17.7107C43.1538 18.0647 43.7783 18.2419 44.4865 18.2419H52.007V21.6247H44.5148C43.4711 21.6247 42.4924 21.4563 41.5792 21.1208C40.666 20.7854 39.8742 20.31 39.2032 19.695C38.5324 19.0801 38.0106 18.3442 37.6378 17.487C37.2837 16.6298 37.1066 15.7071 37.1066 14.7195C37.1066 13.7317 37.2837 12.8092 37.6378 11.9519C38.0106 11.0946 38.5323 10.3579 39.2032 9.74289C39.8741 9.12799 40.6661 8.66222 41.5792 8.34543C42.4924 8.00996 43.4711 7.8425 44.5148 7.8425H48.0646ZM67.8605 7.8425C68.7737 7.8425 69.2306 8.21518 69.2306 8.96066V9.74289C69.2306 10.302 68.9788 10.7957 68.4757 11.2243L60.2286 18.0183H69.2306V21.6247H56.0919C55.0856 21.6247 54.5822 21.1677 54.5822 20.2546V19.3601C54.5822 18.9501 54.647 18.6142 54.7775 18.3532C54.908 18.0737 55.1694 17.7939 55.5607 17.5144L62.9689 11.3923H54.5822V7.8425H67.8605ZM75.7365 21.6247H71.6271V7.8425H75.7365V21.6247ZM88.4865 5.54953H84.6007C83.2588 5.54953 82.588 6.31425 82.588 7.8425H88.5421V11.2527H82.588V21.6247H78.5343V7.36691C78.5343 5.74548 78.9631 4.49677 79.8204 3.62082C80.6964 2.72637 81.9452 2.27902 83.5665 2.27902H88.4865V5.54953ZM94.5197 21.6247H90.4103V7.8425H94.5197V21.6247ZM106.682 7.8425C108.918 7.8425 110.624 8.41954 111.798 9.57492C112.991 10.7118 113.587 12.3245 113.587 14.4118V21.6247H109.478V14.3835C109.478 13.4704 109.226 12.7714 108.723 12.2868C108.238 11.8023 107.53 11.5603 106.598 11.5603H101.454V21.6247H97.3165V7.8425H106.682ZM73.9757 2.67062C74.516 2.6707 74.9538 2.83818 75.2892 3.17355C75.6433 3.49039 75.8204 3.91921 75.8204 4.45969C75.8204 5.00003 75.6432 5.43774 75.2892 5.77316C74.9538 6.08992 74.516 6.24868 73.9757 6.24875H73.4161C72.8571 6.24873 72.4001 6.08998 72.046 5.77316C71.7108 5.43777 71.5431 4.99991 71.5431 4.45969C71.5431 3.91932 71.7107 3.49037 72.046 3.17355C72.4001 2.8381 72.8571 2.67064 73.4161 2.67062H73.9757ZM92.7579 2.67062C93.2984 2.67062 93.7369 2.83808 94.0724 3.17355C94.4263 3.49037 94.6036 3.91932 94.6036 4.45969C94.6036 4.99991 94.4262 5.43777 94.0724 5.77316C93.7369 6.08999 93.2984 6.24875 92.7579 6.24875H92.1993C91.6402 6.24875 91.1833 6.08999 90.8292 5.77316C90.4938 5.43774 90.3263 5.00003 90.3263 4.45969C90.3263 3.91921 90.4938 3.49039 90.8292 3.17355C91.1833 2.83811 91.6402 2.67062 92.1993 2.67062H92.7579Z"
        fill="black"
      />
    </svg>
  </SvgIcon>
);

export const CheckSmallIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#7DDB25"
      />
      <path
        d="M17 9L10.8125 15.1875L8 12.375"
        stroke="#0A0A0A"
        stroke-width="1.76786"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const CurrentListIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="#2049AD"
      />
      <path
        d="M11 16L15 12L11 8"
        stroke="white"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);
export const AUFlagIcons = () => (
  <img src="/images/aus-flag.png" width={20} height={20} />
);

// export const AUFlagIcons = () => (
//   <SvgIcon>
//     <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342">
//       <path fill="#10338c" d="M0 0h513v342H0z" />
//       <g fill="#FFF">
//         <path d="M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zM385.9 241.1l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM337.3 125.1l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zM385.9 58.9l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zM428.4 108.6l5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z" />
//         <path d="M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z" />
//       </g>
//       <path
//         fill="#D80027"
//         d="M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
//       />
//       <path fill="#0052B4" d="m154.6 115 100.2 55.7v-15.8L183 115z" />
//       <path fill="#FFF" d="m154.6 115 100.2 55.7v-15.8L183 115z" />
//       <g fill="#D80027">
//         <path d="m154.6 115 100.2 55.7v-15.8L183 115zM70.7 115l-71.9 39.9v15.8L99 115z" />
//       </g>
//       <path fill="#0052B4" d="M99 55.7-1.2 0v15.7l71.9 40z" />
//       <path fill="#FFF" d="M99 55.7-1.2 0v15.7l71.9 40z" />
//       <g fill="#D80027">
//         <path d="M99 55.7-1.2 0v15.7l71.9 40zM183 55.7l71.8-40V0L154.6 55.7z" />
//       </g>
//     </svg>
//   </SvgIcon>
// );

export const MapPinIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const CloseDialogIcon = () => (
  <SvgIcon sx={{ cursor: "pointer" }}>
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="14" fill="#F3F3F5" />
      <path
        d="M18 10L10 18M10 10L18 18"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const ArrowDownwardIcon = ({ expanded }: { expanded: boolean }) => (
  <SvgIcon
    sx={{
      transition: "transform 0.2s ease",
      transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
      color: "#0A0A0A",
    }}
  >
    <svg
      width="14"
      height="8"
      viewBox="0 0 14 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 1L7 7L13 1"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const ArrowRightIcon = () => (
  <SvgIcon>
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 13L7 7L1 1"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const DownloadIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3"
        stroke="#2D68F7"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const MultiCardIcon = () => (
  <SvgIcon>
    <svg
      width="148"
      height="24"
      viewBox="0 0 148 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.9503 15.7582H8.89051L7.34596 9.69237C7.27264 9.41334 7.11698 9.16667 6.88801 9.0504C6.31659 8.75823 5.68691 8.5257 5 8.40843V8.1749H8.31808C8.77602 8.1749 9.11948 8.5257 9.17672 8.93313L9.97813 13.3086L12.0369 8.1749H14.0394L10.9503 15.7582ZM15.1842 15.7582H13.239L14.8408 8.1749H16.786L15.1842 15.7582ZM19.3027 10.2757C19.3599 9.86728 19.7034 9.63374 20.1041 9.63374C20.7338 9.57511 21.4197 9.69238 21.9921 9.98354L22.3356 8.35081C21.7631 8.11727 21.1335 8 20.562 8C18.674 8 17.3002 9.05041 17.3002 10.5082C17.3002 11.6173 18.2733 12.1996 18.9602 12.5504C19.7034 12.9002 19.9896 13.1338 19.9324 13.4835C19.9324 14.0082 19.3599 14.2418 18.7885 14.2418C18.1016 14.2418 17.4147 14.0669 16.786 13.7747L16.4426 15.4085C17.1295 15.6996 17.8726 15.8169 18.5595 15.8169C20.6765 15.8745 21.9921 14.8251 21.9921 13.25C21.9921 11.2665 19.3027 11.1502 19.3027 10.2757ZM28.8 15.7582L27.2554 8.1749H25.5964C25.2529 8.1749 24.9095 8.40843 24.795 8.75823L21.9349 15.7582H23.9374L24.3371 14.6502H26.7975L27.0265 15.7582H28.8ZM25.8826 10.2171L26.454 13.0751H24.8523L25.8826 10.2171Z"
        fill="#172B85"
      />
      <rect
        x="38.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <path
        d="M59.5771 5.03027C63.322 5.03027 66.3584 8.03016 66.3584 11.7305C66.3583 15.4307 63.322 18.4307 59.5771 18.4307C57.8982 18.4306 56.3629 17.8259 55.1787 16.8271C53.9945 17.8258 52.4591 18.4307 50.7803 18.4307C47.0357 18.4304 44.0001 15.4305 44 11.7305C44 8.0303 47.0356 5.0305 50.7803 5.03027C52.459 5.03027 53.9945 5.63435 55.1787 6.63281C56.3629 5.63422 57.8983 5.0303 59.5771 5.03027Z"
        fill="#ED0006"
      />
      <path
        d="M59.5776 5.03027C63.3224 5.03035 66.3579 8.03021 66.3579 11.7305C66.3578 15.4306 63.3224 18.4306 59.5776 18.4307C57.8987 18.4307 56.3634 17.8258 55.1792 16.8271C56.6364 15.5983 57.562 13.7718 57.562 11.7305C57.562 9.68897 56.6366 7.86171 55.1792 6.63281C56.3634 5.63427 57.8988 5.03027 59.5776 5.03027Z"
        fill="#F9A000"
      />
      <path
        d="M55.1782 6.63281C56.6358 7.86171 57.561 9.68883 57.561 11.7305C57.561 13.7719 56.6356 15.5983 55.1782 16.8271C53.7213 15.5983 52.7964 13.7716 52.7964 11.7305C52.7964 9.68913 53.721 7.86171 55.1782 6.63281Z"
        fill="#FF5E00"
      />
      <rect
        x="76.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="#1F72CD"
        stroke="#D9D9D9"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M82.0952 8.5L78.9141 15.7467H82.7223L83.1944 14.5913H84.2735L84.7457 15.7467H88.9375V14.8649L89.311 15.7467H91.4793L91.8528 14.8462V15.7467H100.571L101.631 14.6213L102.623 15.7467L107.101 15.7561L103.91 12.1436L107.101 8.5H102.693L101.661 9.60463L100.699 8.5H91.2156L90.4013 10.3704L89.5678 8.5H85.7675V9.35186L85.3447 8.5H82.0952ZM82.832 9.52905H84.6884L86.7984 14.4431V9.52905H88.8319L90.4617 13.0524L91.9637 9.52905H93.987V14.7291H92.7559L92.7458 10.6544L90.9509 14.7291H89.8495L88.0446 10.6544V14.7291H85.5118L85.0316 13.5633H82.4374L81.9583 14.728H80.6012L82.832 9.52905ZM100.12 9.52905H95.1134V14.726H100.042L101.631 13.0036L103.162 14.726H104.762L102.436 12.1426L104.762 9.52905H103.231L101.651 11.2316L100.12 9.52905ZM83.7351 10.4089L82.8804 12.4856H84.5888L83.7351 10.4089ZM96.3497 11.555V10.6057V10.6048H99.4734L100.836 12.1229L99.413 13.6493H96.3497V12.613H99.0808V11.555H96.3497Z"
        fill="white"
      />
      <rect
        x="114.5"
        y="0.5"
        width="33"
        height="23"
        rx="3.5"
        fill="white"
        stroke="#D9D9D9"
      />
      <path
        d="M124.519 5.00098H129.877C130.625 5.00098 131.09 5.62855 130.915 6.40106L128.421 17.4264C128.245 18.1962 127.496 18.8244 126.747 18.8244H121.39C120.643 18.8244 120.177 18.1962 120.351 17.4264L122.847 6.40106C123.021 5.62855 123.77 5.00098 124.519 5.00098Z"
        fill="#E21836"
      />
      <path
        d="M129.431 5H135.593C136.34 5 136.003 5.62758 135.827 6.40009L133.333 17.4255C133.158 18.1953 133.213 18.8234 132.463 18.8234H126.301C125.552 18.8234 125.088 18.1953 125.264 17.4255L127.758 6.40009C127.936 5.62758 128.682 5 129.431 5Z"
        fill="#00447C"
      />
      <path
        d="M135.348 5H140.706C141.455 5 141.92 5.62758 141.745 6.40009L139.25 17.4255C139.074 18.1953 138.325 18.8234 137.576 18.8234H132.22C131.471 18.8234 131.006 18.1953 131.182 17.4255L133.676 6.40009C133.851 5.62758 134.599 5 135.348 5Z"
        fill="#007B84"
      />
      <path
        d="M125.918 8.53314C125.367 8.53892 125.204 8.53314 125.152 8.5205C125.132 8.61824 124.76 10.3839 124.759 10.3854C124.679 10.7426 124.621 10.9972 124.423 11.1616C124.311 11.2572 124.179 11.3033 124.027 11.3033C123.783 11.3033 123.641 11.1784 123.617 10.9415L123.612 10.8602C123.612 10.8602 123.687 10.3817 123.687 10.379C123.687 10.379 124.077 8.77003 124.147 8.55734C124.15 8.54524 124.151 8.53892 124.152 8.53314C123.393 8.54 123.258 8.53314 123.249 8.5205C123.244 8.53784 123.225 8.6376 123.225 8.6376L122.827 10.4511L122.792 10.6049L122.726 11.108C122.726 11.2572 122.755 11.379 122.811 11.482C122.993 11.8086 123.511 11.8575 123.804 11.8575C124.181 11.8575 124.535 11.775 124.774 11.6242C125.19 11.3716 125.298 10.9768 125.395 10.6259L125.44 10.4459C125.44 10.4459 125.842 8.77473 125.91 8.55734C125.913 8.54524 125.914 8.53892 125.918 8.53314ZM127.285 9.88125C127.188 9.88125 127.011 9.90545 126.852 9.98571C126.795 10.0162 126.74 10.0515 126.682 10.0865L126.734 9.89335L126.706 9.86081C126.369 9.93113 126.293 9.94054 125.981 9.98571L125.955 10.0036C125.919 10.3124 125.887 10.5446 125.753 11.1516C125.702 11.3753 125.649 11.6012 125.596 11.8243L125.61 11.8527C125.929 11.8354 126.026 11.8354 126.304 11.8401L126.326 11.8149C126.361 11.629 126.366 11.5854 126.444 11.2089C126.481 11.0303 126.557 10.638 126.595 10.4983C126.664 10.4653 126.733 10.4327 126.798 10.4327C126.954 10.4327 126.935 10.5724 126.929 10.6281C126.922 10.7215 126.865 11.0267 126.807 11.2887L126.769 11.4579C126.742 11.5828 126.712 11.7042 126.685 11.828L126.697 11.8527C127.011 11.8354 127.107 11.8354 127.376 11.8401L127.408 11.8149C127.456 11.5245 127.471 11.4468 127.557 11.024L127.6 10.8297C127.684 10.4495 127.727 10.2567 127.663 10.0997C127.596 9.92373 127.434 9.88125 127.285 9.88125ZM128.813 10.2793C128.646 10.3124 128.539 10.3344 128.433 10.3487C128.328 10.366 128.226 10.3818 128.064 10.4049L128.051 10.4169L128.039 10.4264C128.022 10.5504 128.011 10.6575 127.988 10.7835C127.969 10.9138 127.94 11.0618 127.893 11.2745C127.856 11.4373 127.837 11.494 127.816 11.5513C127.796 11.6086 127.774 11.6642 127.732 11.8243L127.742 11.8391L127.75 11.8527C127.901 11.8453 128 11.8401 128.102 11.8391C128.203 11.8354 128.308 11.8391 128.471 11.8401L128.485 11.8281L128.5 11.8149C128.524 11.6705 128.528 11.6317 128.542 11.5612C128.556 11.4857 128.581 11.3811 128.641 11.1017C128.669 10.9705 128.701 10.8397 128.731 10.7058C128.761 10.5724 128.793 10.4411 128.824 10.3098L128.819 10.294L128.813 10.2793ZM128.817 9.7426C128.665 9.65024 128.398 9.67954 128.218 9.80713C128.039 9.93216 128.019 10.1096 128.17 10.2032C128.32 10.293 128.588 10.2663 128.766 10.1376C128.944 10.0099 128.967 9.83402 128.817 9.7426ZM129.736 11.8816C130.044 11.8816 130.359 11.7944 130.596 11.5355C130.779 11.3255 130.863 11.013 130.892 10.8844C130.986 10.4579 130.913 10.2588 130.82 10.1375C130.68 9.95266 130.432 9.89338 130.175 9.89338C130.02 9.89338 129.652 9.90911 129.364 10.1822C129.158 10.3791 129.062 10.6464 129.005 10.9026C128.946 11.1637 128.88 11.6337 129.299 11.8086C129.429 11.8659 129.616 11.8816 129.736 11.8816ZM129.712 10.9221C129.783 10.5992 129.867 10.3282 130.08 10.3282C130.248 10.3282 130.26 10.5298 130.186 10.8538C130.172 10.9258 130.111 11.1932 130.028 11.307C129.971 11.3911 129.902 11.442 129.827 11.442C129.804 11.442 129.671 11.442 129.669 11.2378C129.668 11.137 129.688 11.034 129.712 10.9221ZM131.66 11.8401L131.685 11.815C131.719 11.629 131.724 11.5853 131.8 11.2089C131.837 11.0304 131.916 10.6381 131.952 10.4984C132.022 10.4652 132.089 10.4326 132.156 10.4326C132.311 10.4326 132.292 10.5723 132.286 10.628C132.28 10.7216 132.224 11.0266 132.164 11.2886L132.128 11.4578C132.1 11.5828 132.069 11.7041 132.042 11.828L132.054 11.8528C132.37 11.8354 132.462 11.8354 132.732 11.8401L132.765 11.815C132.812 11.5244 132.825 11.4467 132.914 11.0241L132.956 10.8296C133.041 10.4494 133.084 10.2568 133.021 10.0998C132.952 9.92377 132.789 9.88129 132.643 9.88129C132.546 9.88129 132.368 9.90535 132.209 9.98575C132.153 10.0163 132.096 10.0514 132.041 10.0866L132.089 9.89339L132.063 9.86072C131.726 9.93117 131.649 9.94058 131.337 9.98575L131.314 10.0036C131.276 10.3124 131.245 10.5445 131.111 11.1516C131.06 11.3753 131.007 11.6012 130.954 11.8244L130.968 11.8528C131.288 11.8354 131.383 11.8354 131.66 11.8401ZM133.981 11.8527C134.001 11.7529 134.118 11.1617 134.12 11.1617C134.12 11.1617 134.22 10.7278 134.226 10.7121C134.226 10.7121 134.258 10.6669 134.289 10.649H134.336C134.774 10.649 135.27 10.649 135.658 10.355C135.922 10.1533 136.103 9.85554 136.184 9.49362C136.204 9.40489 136.22 9.29935 136.22 9.19382C136.22 9.05521 136.193 8.91807 136.115 8.81092C135.917 8.52577 135.522 8.52053 135.067 8.51838C135.066 8.51838 134.843 8.52053 134.843 8.52053C134.26 8.52792 134.027 8.52577 133.931 8.51367C133.923 8.55737 133.907 8.63507 133.907 8.63507C133.907 8.63507 133.699 9.63076 133.699 9.63237C133.699 9.63237 133.199 11.7493 133.176 11.8491C133.684 11.8427 133.893 11.8427 133.981 11.8527ZM134.367 10.084C134.367 10.084 134.589 9.0903 134.588 9.09406L134.595 9.04311L134.599 9.00425L134.687 9.01366C134.687 9.01366 135.145 9.05413 135.156 9.05521C135.336 9.12713 135.411 9.31253 135.359 9.55453C135.311 9.77568 135.172 9.96162 134.993 10.0514C134.845 10.1275 134.665 10.1338 134.479 10.1338H134.358L134.367 10.084ZM135.749 10.9405C135.69 11.1979 135.623 11.6679 136.041 11.8354C136.174 11.8937 136.293 11.9111 136.415 11.9048C136.543 11.8976 136.661 11.8315 136.771 11.7363C136.761 11.7754 136.752 11.8145 136.742 11.8538L136.761 11.8789C137.061 11.8659 137.154 11.8659 137.48 11.8685L137.509 11.8453C137.557 11.5576 137.602 11.2783 137.725 10.7278C137.786 10.4642 137.846 10.2031 137.907 9.94055L137.898 9.91165C137.562 9.97578 137.472 9.98949 137.148 10.0367L137.124 10.0572C137.121 10.084 137.117 10.1097 137.114 10.1354C137.064 10.0517 136.991 9.98035 136.878 9.93585C136.735 9.87763 136.397 9.95265 136.107 10.2248C135.903 10.419 135.805 10.6852 135.749 10.9405ZM136.455 10.9563C136.527 10.6391 136.61 10.3708 136.824 10.3708C136.959 10.3708 137.031 10.4994 137.016 10.7188C137.005 10.7736 136.992 10.8312 136.977 10.8964C136.956 10.9907 136.933 11.0841 136.91 11.1777C136.887 11.2417 136.86 11.3021 136.831 11.3422C136.776 11.4226 136.645 11.4725 136.569 11.4725C136.548 11.4725 136.416 11.4725 136.411 11.2719C136.41 11.172 136.43 11.0692 136.455 10.9563ZM140.142 9.90908L140.116 9.87856C139.783 9.94793 139.723 9.95896 139.417 10.0014L139.395 10.0246C139.394 10.0283 139.393 10.0341 139.391 10.0394L139.39 10.0341C139.163 10.5744 139.17 10.4579 138.984 10.8832C138.983 10.8639 138.983 10.8518 138.982 10.8312L138.936 9.90908L138.907 9.87856C138.558 9.94793 138.55 9.95896 138.228 10.0014L138.203 10.0246C138.2 10.0356 138.2 10.0477 138.198 10.0609L138.2 10.0656C138.24 10.2772 138.23 10.23 138.271 10.5639C138.289 10.7278 138.315 10.8927 138.333 11.0545C138.365 11.3254 138.383 11.4588 138.422 11.8722C138.204 12.2414 138.153 12.3811 137.944 12.7051L137.945 12.7083L137.798 12.9482C137.781 12.9734 137.766 12.9908 137.744 12.9982C137.721 13.0101 137.69 13.0123 137.648 13.0123H137.566L137.445 13.4277L137.861 13.4351C138.105 13.434 138.259 13.3164 138.342 13.1583L138.603 12.6966H138.599L138.627 12.6641C138.803 12.2739 140.142 9.90908 140.142 9.90908ZM135.749 15.3651H135.572L136.226 13.1399H136.443L136.512 12.9107L136.518 13.1656C136.51 13.3232 136.63 13.4629 136.947 13.4397H137.313L137.439 13.0113H137.301C137.222 13.0113 137.185 12.9907 137.19 12.9466L137.183 12.6873H136.505V12.6886C136.286 12.6933 135.632 12.7103 135.5 12.7466C135.34 12.789 135.171 12.9141 135.171 12.9141L135.237 12.6846H134.604L134.472 13.1399L133.809 15.3991H133.681L133.555 15.8245H134.817L134.775 15.9663H135.396L135.438 15.8245H135.612L135.749 15.3651ZM135.231 13.5921C135.13 13.621 134.941 13.7086 134.941 13.7086L135.109 13.1399H135.612L135.491 13.5543C135.491 13.5543 135.335 13.5637 135.231 13.5921ZM135.241 14.4045C135.241 14.4045 135.083 14.4249 134.979 14.4491C134.876 14.4811 134.684 14.582 134.684 14.582L134.857 13.9901H135.363L135.241 14.4045ZM134.959 15.3703H134.454L134.6 14.8709H135.103L134.959 15.3703ZM136.175 13.9901H136.903L136.798 14.3389H136.061L135.95 14.7202H136.595L136.107 15.4286C136.072 15.4806 136.042 15.499 136.008 15.5137C135.973 15.5315 135.928 15.5525 135.876 15.5525H135.697L135.574 15.9701H136.043C136.286 15.9701 136.43 15.8561 136.536 15.7064L136.871 15.2343L136.943 15.7137C136.959 15.8035 137.021 15.8561 137.064 15.8765C137.111 15.9007 137.159 15.9423 137.227 15.9484C137.301 15.9517 137.354 15.9542 137.389 15.9542H137.619L137.757 15.4869H137.667C137.615 15.4869 137.525 15.4779 137.51 15.4611C137.494 15.4407 137.494 15.4092 137.486 15.3613L137.413 14.8808H137.114L137.245 14.7202H137.981L138.095 14.3389H137.413L137.519 13.9901H138.199L138.325 13.5601H136.299L136.175 13.9901ZM130.026 15.4674L130.196 14.8856H130.895L131.022 14.4528H130.323L130.43 14.0947H131.113L131.24 13.6756H129.531L129.407 14.0947H129.795L129.691 14.4528H129.302L129.173 14.893H129.561L129.335 15.6628C129.304 15.7647 129.349 15.8036 129.377 15.8509C129.407 15.897 129.436 15.9275 129.502 15.9449C129.571 15.9606 129.618 15.97 129.681 15.97H130.469L130.609 15.4906L130.26 15.5399C130.193 15.5399 130.006 15.5316 130.026 15.4674ZM130.107 12.682L129.93 13.0112C129.892 13.0831 129.858 13.1278 129.827 13.1483C129.8 13.1657 129.746 13.1729 129.669 13.1729H129.576L129.453 13.5941H129.76C129.907 13.5941 130.02 13.5385 130.074 13.5107C130.133 13.4787 130.148 13.4969 130.193 13.4523L130.296 13.36H131.254L131.381 12.9214H130.68L130.802 12.682H130.107ZM131.52 15.4759C131.504 15.4517 131.516 15.4091 131.541 15.3204L131.802 14.4286H132.733C132.869 14.4266 132.967 14.425 133.031 14.4203C133.099 14.4129 133.174 14.3877 133.255 14.3426C133.338 14.2952 133.381 14.2453 133.417 14.1881C133.458 14.1309 133.523 14.0059 133.578 13.8131L133.907 12.6846L132.941 12.6904C132.941 12.6904 132.643 12.7356 132.513 12.7854C132.38 12.8411 132.191 12.9965 132.191 12.9965L132.279 12.6872H131.682L130.846 15.5399C130.817 15.6507 130.797 15.7311 130.792 15.7793C130.791 15.8314 130.856 15.8829 130.898 15.9217C130.948 15.9606 131.022 15.9542 131.093 15.9606C131.168 15.9663 131.274 15.97 131.42 15.97H131.879L132.02 15.4806L131.609 15.5205C131.565 15.5205 131.533 15.4963 131.52 15.4759ZM131.971 13.8263H132.949L132.887 14.0269C132.878 14.0316 132.857 14.0169 132.758 14.029H131.911L131.971 13.8263ZM132.167 13.1535H133.153L133.082 13.3951C133.082 13.3951 132.618 13.3904 132.543 13.4045C132.216 13.4629 132.024 13.643 132.024 13.643L132.167 13.1535ZM132.909 14.6986C132.901 14.7286 132.888 14.7469 132.87 14.7606C132.85 14.7737 132.818 14.7785 132.77 14.7785H132.631L132.639 14.5342H132.059L132.036 15.7284C132.035 15.8146 132.043 15.8645 132.104 15.9044C132.166 15.9543 132.354 15.9606 132.608 15.9606H132.972L133.103 15.5136L132.786 15.5315L132.681 15.5378C132.667 15.5315 132.653 15.5257 132.638 15.51C132.625 15.4964 132.602 15.5047 132.606 15.4185L132.608 15.1124L132.94 15.0983C133.119 15.0983 133.195 15.0383 133.261 14.9812C133.323 14.9265 133.343 14.8636 133.367 14.7785L133.423 14.5074H132.967L132.909 14.6986Z"
        fill="#FEFEFE"
      />
    </svg>
  </SvgIcon>
);

export const EditIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 20.0002H21M16.5 3.50023C16.8978 3.1024 17.4374 2.87891 18 2.87891C18.2786 2.87891 18.5544 2.93378 18.8118 3.04038C19.0692 3.14699 19.303 3.30324 19.5 3.50023C19.697 3.69721 19.8532 3.93106 19.9598 4.18843C20.0665 4.4458 20.1213 4.72165 20.1213 5.00023C20.1213 5.2788 20.0665 5.55465 19.9598 5.81202C19.8532 6.06939 19.697 6.30324 19.5 6.50023L7 19.0002L3 20.0002L4 16.0002L16.5 3.50023Z"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const RemoveIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6H5M5 6H21M5 6V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V6H5ZM8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M10 11V17M14 11V17"
        stroke="#0A0A0A"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const FolderIcon = () => (
  <SvgIcon>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 19C22 19.5304 21.7893 20.0391 21.4142 20.4142C21.0391 20.7893 20.5304 21 20 21H4C3.46957 21 2.96086 20.7893 2.58579 20.4142C2.21071 20.0391 2 19.5304 2 19V5C2 4.46957 2.21071 3.96086 2.58579 3.58579C2.96086 3.21071 3.46957 3 4 3H9L11 6H20C20.5304 6 21.0391 6.21071 21.4142 6.58579C21.7893 6.96086 22 7.46957 22 8V19Z"
        stroke="#0053FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);

export const DollarIcon = () => (
  <SvgIcon>
    <svg
      width="14"
      height="24"
      viewBox="0 0 14 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 1V23M12 5H4.5C3.57174 5 2.6815 5.36875 2.02513 6.02513C1.36875 6.6815 1 7.57174 1 8.5C1 9.42826 1.36875 10.3185 2.02513 10.9749C2.6815 11.6313 3.57174 12 4.5 12H9.5C10.4283 12 11.3185 12.3687 11.9749 13.0251C12.6313 13.6815 13 14.5717 13 15.5C13 16.4283 12.6313 17.3185 11.9749 17.9749C11.3185 18.6313 10.4283 19 9.5 19H1"
        stroke="#0053FD"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </SvgIcon>
);
